export default "__VITE_ASSET__GKFTI73H__"